import React, {ButtonHTMLAttributes} from 'react';
import styled from 'styled-components';
import StyledIcon from 'components/acommon/StyledIcon';

export const RoundButtonStyled = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  height: 38px;
  width: 38px;
  color: #777e90;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.07s ease-in-out;

  /* &:hover {
    background: #353945;
    border: 2px solid #353945;
    color: #fcfcfd;
  } */
`;

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: React.ReactNode | string;
  icon?: React.ReactNode;
  title?: string;
};

const defaultProps: ButtonProps = {
  label: '',
  icon: null,
  title: undefined,
};

function RoundButton({icon, label, disabled, className, title, ...props}: ButtonProps) {
  return (
    <RoundButtonStyled disabled={disabled} className={className} title={title} {...props}>
      <StyledIcon name={icon} size="24" color="#777e90" />
    </RoundButtonStyled>
  );
}

RoundButton.defaultProps = defaultProps;
export default RoundButton;
